module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('box', {
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('router-link', {
    staticClass: "padding",
    attrs: {
      "to": "/nova-campanha"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Nova Campanha")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("ucwords")(coluna)) + "\n                              ")])])])])
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.campanhas.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Nenhum Pedido Localizado")])]) : _vm._l((_vm.campanhas), function(c, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("Cupom")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.verificarPremio(c)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.codigo))]), _vm._v(" "), _c('td', [_c('toggle-button', {
      attrs: {
        "color": _vm.color,
        "sync": true
      },
      on: {
        "change": function($event) {
          return _vm.changeStatus(c.ativo, c.id)
        }
      },
      model: {
        value: (c.ativo),
        callback: function($$v) {
          _vm.$set(c, "ativo", $$v)
        },
        expression: "c.ativo"
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "grupo_btn_acoes"
    }, [_c('router-link', {
      staticClass: "btn_editar",
      attrs: {
        "to": {
          name: 'Editar Campanha',
          params: {
            id: c.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])])
  })], 2), _vm._v(" "), _c('tfoot')])])])])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00979abb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campanhas/Campanhas.vue
// module id = 1193
// module chunks = 1